import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useField } from "formik";
import { SingleButtonSelector } from "src/components/ButtonSelector/SingleButtonSelector";
import { IFormField, ISelectOption } from "src/@types/form";
import { FormField } from ".";

export const SingleButtonSelectorField: FC<IFormField> = ({
  className,
  fieldClassName,
  labelClassName,
  id,
  label,
  options,
  variant,
  errorClassName,
  selectorClassName,
  fieldDescription,
  fieldDescriptionClassName,
  ...props
}) => {
  const { t } = useTranslation();

  const name = props.name as string;

  const fieldId = id || name;

  const [{ value }, { error, touched }, { setValue }] = useField(fieldId);
  const isShownError = Boolean((touched || value) && error);

  const setActiveOption = ({ value }: ISelectOption) => setValue(value);

  const description =
    typeof fieldDescription === "string"
      ? fieldDescription
      : t(fieldDescription?.i18nKey, fieldDescription?.i18nParams);

  return (
    <div className="flex-1">
      <FormField
        className={fieldClassName}
        labelClassName={labelClassName}
        label={label}
        labelFor={fieldId}
        error={error}
        errorClassName={errorClassName}
        isShownError={isShownError}
        {...props}
      >
        <SingleButtonSelector
          className={className}
          selectorClassName={selectorClassName}
          options={options}
          activeOption={value}
          setActiveOption={setActiveOption}
        />
      </FormField>
      {description && (
        <div className={fieldDescriptionClassName}>{description}</div>
      )}
    </div>
  );
};
